import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=03d8576e&scoped=true&"
import script from "./teaching.vue?vue&type=script&lang=ts&"
export * from "./teaching.vue?vue&type=script&lang=ts&"
import style0 from "./teaching.vue?vue&type=style&index=0&id=03d8576e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8576e",
  null
  
)

export default component.exports